import { get, cloneDeep } from 'lodash';
import { APIS } from '../constants/apis';
import { PostRecord } from './PostRecord';
import { GetUpdateDependencies } from '../../pages/private/online-antrag/OnlineAntrag';
import { isArray } from 'lodash';

import MittelabrufSchema from '../paths/mittelabruf_FULL_Paths.json';
const MA_P = MittelabrufSchema.attributes;

export async function PushNotificationApplication(api: string, application: any) {
	let entries: any[] = [];

	if (api === APIS.Antrag) {
		let relations = cloneDeep(get(GetUpdateDependencies(application, api), 'relations', []));

		for (let ele of relations) {
			if (get(ele, 'api') === APIS.Organisation) {
				entries.push({ api: get(ele, 'api'), id: get(application, `${get(ele, 'field')}.id`) });
			}
		}
		entries.push({ api: APIS.Antrag, id: get(application, 'id') });

		for (let relation of relations) {
			if (get(relation, 'api') !== APIS.Organisation) {
				let values = get(application, get(relation, 'field', []));
				values = isArray(values) ? values : [values];

				for (let value of values) {
					entries.push({ api: get(relation, 'api'), id: get(value, 'id') });
				}
			}
		}
	}
	if (api === APIS.Mittelabruf) {
		entries.push({ api: APIS.Mittelabruf, id: get(application, 'id') });
		let relations = cloneDeep(get(GetUpdateDependencies(application, api), 'relations', []));

		entries.push({ api: APIS.Verwendungsnachweis, id: get(application, `${MA_P.Mittelabruf_Verwendungsnachweiss.path}.id`) });

		for (let relation of relations) {
			let values = get(application, get(relation, 'field', []));
			values = isArray(values) ? values : [values];

			for (let value of values) {
				entries.push({ api: get(relation, 'api'), id: get(value, 'id') });
			}
		}
	}

	if (api === APIS.Verwendungsnachweis) {
		let relations = cloneDeep(get(GetUpdateDependencies(application, api), 'relations', []));

		entries.push({ api: APIS.Verwendungsnachweis, id: get(application, 'id') });

		for (let relation of relations) {
			let values = get(application, get(relation, 'field', []));
			values = isArray(values) ? values : [values];

			for (let value of values) {
				entries.push({ api: get(relation, 'api'), id: get(value, 'id') });
			}
		}
	}
	if (api === APIS.Zwischenbericht) {
		entries.push({ api: APIS.Zwischenbericht, id: get(application, 'id') });
	}
	if (api === APIS.Abschlussbericht) {
		entries.push({ api: APIS.Abschlussbericht, id: get(application, 'id') });
	}
	if (api === APIS.AenderungsAnfrage) {
		entries.push({ api: APIS.AenderungsAnfrage, id: get(application, 'id') });
	}

	await PostRecord(APIS.PushNotificaiton, { data: { entities: entries } });
}
